// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WCm8","field":"styles_field__2YHMt","fieldCol":"styles_fieldCol__1F6SH","diffCol":"styles_diffCol__3GDNW","diff":"styles_diff__3sPlf"};